import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
  code: "ar",
  dir: "rtl",
  messages: {
    alert: {
      close: "\u0625\u063A\u0644\u0627\u0642"
    },
    authForm: {
      hidePassword: "\u0625\u062E\u0641\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      showPassword: "\u0625\u0638\u0647\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      submit: "\u0645\u062A\u0627\u0628\u0639\u0629"
    },
    banner: {
      close: "\u0625\u063A\u0644\u0627\u0642"
    },
    calendar: {
      nextMonth: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0645\u0642\u0628\u0644",
      nextYear: "\u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0645\u0642\u0628\u0644\u0629",
      prevMonth: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0633\u0627\u0628\u0642",
      prevYear: "\u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629"
    },
    carousel: {
      dots: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0634\u0631\u064A\u062D\u0629 \u0627\u0644\u0645\u0631\u0627\u062F \u0639\u0631\u0636\u0647\u0627",
      goto: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0634\u0631\u064A\u062D\u0629 {slide}",
      next: "\u0627\u0644\u062A\u0627\u0644\u064A",
      prev: "\u0627\u0644\u0633\u0627\u0628\u0642"
    },
    chatPrompt: {
      placeholder: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u062A\u0643 \u0647\u0646\u0627..."
    },
    chatPromptSubmit: {
      label: "\u0625\u0631\u0633\u0627\u0644"
    },
    colorMode: {
      dark: "\u062F\u0627\u0643\u0646",
      light: "\u0641\u0627\u062A\u062D",
      switchToDark: "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062F\u0627\u0643\u0646",
      switchToLight: "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D",
      system: "\u0627\u0644\u0646\u0638\u0627\u0645"
    },
    commandPalette: {
      back: "\u0631\u062C\u0648\u0639",
      close: "\u0625\u063A\u0644\u0627\u0642",
      noData: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
      noMatch: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0645\u0637\u0627\u0628\u0642\u0629",
      placeholder: "\u0627\u0643\u062A\u0628 \u0623\u0645\u0631\u064B\u0627 \u0623\u0648 \u0627\u0628\u062D\u062B..."
    },
    contentSearch: {
      links: "\u0627\u0644\u0631\u0648\u0627\u0628\u0637",
      theme: "\u0627\u0644\u0633\u0645\u0629"
    },
    contentSearchButton: {
      label: "\u0628\u062D\u062B..."
    },
    contentToc: {
      title: "\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629"
    },
    dashboardSearch: {
      theme: "\u0627\u0644\u0633\u0645\u0629"
    },
    dashboardSearchButton: {
      label: "\u0628\u062D\u062B..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u0637\u064A \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A",
      expand: "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A"
    },
    dashboardSidebarToggle: {
      close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A",
      open: "\u0641\u062A\u062D \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A"
    },
    error: {
      clear: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629"
    },
    fileUpload: {
      removeFile: "\u0625\u0632\u0627\u0644\u0629 {filename}"
    },
    header: {
      close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
      open: "\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629"
    },
    inputMenu: {
      create: '\u0625\u0646\u0634\u0627\u0621 "{label}"',
      noData: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
      noMatch: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0645\u0637\u0627\u0628\u0642\u0629"
    },
    inputNumber: {
      decrement: "\u062A\u0642\u0644\u064A\u0644",
      increment: "\u0632\u064A\u0627\u062F\u0629"
    },
    modal: {
      close: "\u0625\u063A\u0644\u0627\u0642"
    },
    pricingTable: {
      caption: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u062E\u0637\u0637 \u0627\u0644\u0633\u0639\u0631\u064A\u0629"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0637\u064A",
        name: "\u0643\u0648\u062F",
        openText: "\u062A\u0648\u0633\u064A\u0639"
      },
      collapsible: {
        closeText: "\u0625\u062E\u0641\u0627\u0621",
        name: "\u062E\u0635\u0627\u0626\u0635",
        openText: "\u0625\u0638\u0647\u0627\u0631"
      },
      pre: {
        copy: "\u0646\u0633\u062E \u0627\u0644\u0643\u0648\u062F \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629"
      }
    },
    selectMenu: {
      create: '\u0625\u0646\u0634\u0627\u0621 "{label}"',
      noData: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
      noMatch: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0645\u0637\u0627\u0628\u0642\u0629",
      search: "\u0628\u062D\u062B..."
    },
    slideover: {
      close: "\u0625\u063A\u0644\u0627\u0642"
    },
    table: {
      noData: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A"
    },
    toast: {
      close: "\u0625\u063A\u0644\u0627\u0642"
    }
  }
});
